/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { requestTypeTableEntrypoint } from '@jira/servicedesk__request-types-table/src/requestTypeTableEntrypoint.entrypoint.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type NestedEntryPoints = {
	// The below is required to fix an type error in the entrypoint that only appears in the CI. It's a known issue with nested entrypoints.
	// https://atlassian.slack.com/archives/C07JUC8ALCT/p1741233995361509?thread_ts=1741215074.681649&cid=C07JUC8ALCT
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	requestTypeTableEntrypoint: any;
};

type TicketTypesConfigEntrypointComponent = EntryPointComponent<{}, NestedEntryPoints, {}, {}>;

export const TicketTypesConfigEntrypoint: EntryPoint<
	TicketTypesConfigEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<TicketTypesConfigEntrypointComponent>(
		/* webpackChunkName: "async-project-settings-service-desk-ticket-types-config-entrypoint", jiraSpaEntry: "async-project-settings-service-desk-ticket-types-config-entrypoint" */ './ServiceDeskRequestTypesConfigPageNew.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const cloudId = tenantContext.cloudId;
		const projectKey = context.match.params.projectKey;

		if (!projectKey) {
			throw new Error('Project key is required');
		}

		return {
			entryPoints: {
				requestTypeTableEntrypoint: {
					entryPoint: requestTypeTableEntrypoint,
					entryPointParams: {
						projectKey,
						cloudId,
					},
				},
			},
		};
	},
});
